<div class="m-validation-message"
     @click="onClick">
    <m-accordion-transition :disabled="!transition">
        <p :class="['m-validation-message__' + classMessage]"
           v-if="message">
            <m-icon class="m-validation-message__icon"
                    :name="iconName"
                    :svg-title="svgTitle"
                    size="1em">
            </m-icon>
            <span class="m-validation-message__text"
                  v-html="message"></span>
        </p>
    </m-accordion-transition>
    <m-accordion-transition :disabled="!transition">
        <p class="m-validation-message__helper"
           v-if="hasHelperMessage"
           v-html="helperMessage"></p>
    </m-accordion-transition>
</div>
